<template>
  <vs-prompt
    class="myPrompt"
    :title="this.checkInfoTitle"
    @close="closeCheckInfo"
    :active.sync="checkViewPopUp"
    buttons-hidden
  >
    <span v-html="this.checkInfo"></span>
  </vs-prompt>
</template>

<script>
export default {
  name: "CheckInfo",
  props: ["checkInfoTitle", "checkInfo"],
  data() {
    return {
      checkViewPopUp: true,
    };
  },
  mounted() {
    Event.$on("hideCheckViewPopUp", () => {
      this.$router.go(0);
    });
  },
  methods: {
    closeCheckInfo() {
      Event.$emit("hideCheckInfoViewComp");
    },
  },
};
</script>

<style scoped>
.myPrompt >>> .dialog-title {
  color: white;
}
</style>
